module.exports = {
	"refunds": {
		"title": "Refunds",
		"operation_id": "Operation ID",
		"order_guid": "Order GUID",
		"operation_type": "Operation type",
		"provider_name": "Payment provider",
		"amount": "Refund amount",
		"status_updated_at": "Transition time (paid → refunded)",
		"created_at": "Actual refund processing time",
		"refund_reason": "Refund reason"
	}
};